// Separate file for testing purposes

import noImage from '!!url!./noimage.svg';
export default noImage;
